<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Progress Bar" pageTitle="Progress Bar" />
            <ProgressBar />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ProgressBar from '../ProgressBar/ProgressBar'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ProgressBarPage',
    components: {
        MainHeader,
        PageTitle,
        ProgressBar,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>